import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface SideMenuInterface {
  title: string;
  isClicked: boolean;
  hideSideMenuBar: boolean;
}

const initialState: SideMenuInterface = {
  title: "",
  isClicked: false,
  hideSideMenuBar: false,
};

export const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    setSideMenuOption: (state, action: PayloadAction<string>) => {
      const title = action.payload;
      if (state.title === title) {
        state.isClicked = !state.isClicked;
      } else {
        state.title = title;
        state.isClicked = true;
      }
    },
    setShowSideMenuBar: (state, action: PayloadAction<boolean>) => {
      state.hideSideMenuBar = action.payload;
    },
  },
});

export const { setSideMenuOption, setShowSideMenuBar } = sideMenuSlice.actions;
export const sideMenuReducer = sideMenuSlice.reducer;
